export default __webpack_public_path__ + "static/media/cheveron-right.bb3461ed.svg";